export default {
  data () {
    return {
      communicationDetails: null,
      extension: null,
      extensionOwnerType: 'Campaign',
      extensionType: 0,
      isTracked: false,
      rewardId: null,
      rewardType: null,
    }
  },

  methods: {
    configureExtension() {
      let extension = { name: '--' }
      switch (this.extensionType) {
        case 1:
        case 5:
        case 6:
          extension = {
            loadImagesUrl: ``,
            name: 'offer',
            ownerId: this.communicationDetails ? this.communicationDetails.id : null,
            ownerType: this.extensionOwnerType,
          }
          break
        case 3:
          extension = {
            name: 'wallet target',
            value: this.communicationDetails.wallet_target,
          }
          break
        case 4:
          extension = {
            name: 'any link',
            value: this.communicationDetails.any_links,
          }
          break
      }
      return extension
    },

    updateRewardType(name) {
      this.rewardType = name
    }
  },

  computed: {
    isOffer: function () {
      return this.rewardId && [1, 5, 6].includes(this.extensionType)
    },
  },
}